// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","card__picture":"Card_card__picture__Dn9tP","card__item":"Card_card__item__LMt-C","card__name":"Card_card__name__WeYX5"};